import { render, staticRenderFns } from "./moreNews.vue?vue&type=template&id=40d1b528&scoped=true"
import script from "./moreNews.vue?vue&type=script&lang=js"
export * from "./moreNews.vue?vue&type=script&lang=js"
import style0 from "./moreNews.vue?vue&type=style&index=0&id=40d1b528&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d1b528",
  null
  
)

export default component.exports